import { render, staticRenderFns } from "./PowerContractPlacementEditor.vue?vue&type=template&id=21e3a0fe&scoped=true"
import script from "./PowerContractPlacementEditor.vue?vue&type=script&lang=js"
export * from "./PowerContractPlacementEditor.vue?vue&type=script&lang=js"
import "./PowerContractPlacementEditor.vue?vue&type=style&index=0&id=21e3a0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3a0fe",
  null
  
)

export default component.exports